export default __webpack_public_path__ + "static/media/company.fe130fd0.png";